// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3CSYa","header":"ReportDetails_header__3FmTX","title":"ReportDetails_title__2SvAD","left":"ReportDetails_left__1zIvl"};